export interface ISynergyConfigTest {
  status: boolean;
  message?: string;
}
